export const offerChoiceAction = ({
  choosingThisOffer,
  choosingAnyOffer,
  beneficiaryFormOpen,
  pricesLoading,
}) => ({
  loading: Boolean(choosingThisOffer || pricesLoading),
  disabled: Boolean(choosingAnyOffer || beneficiaryFormOpen || pricesLoading),
});
